import React, { useContext, useEffect, useRef, useState } from "react";
import "./Banner.css";
import axios from "axios";
import { Col, Form, Row } from "react-bootstrap";
import {
  FaCalendarAlt,
  FaCar,
  FaClock,
  FaMapMarkerAlt,
  FaUsers,
} from "react-icons/fa";
import Select from "react-select";
import Common_Css from "../../common/common-css/Common_Css.css";
import Yellow_BG_Btn from "../../common/common-btn/yellow-bg-btn/Yellow_BG_Btn";
import { useNavigate } from "react-router-dom";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDataBanner } from "../../../utils/apis/Home/Homeapi";
import { Context } from "../../../utils/context";
import { getcabs, GetCancelltionReason, getLocation } from "../../../utils/apis/master/Master";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import { encodeId, formatAmount } from "../../../utils/common";
import Success_Modal from "../../success-modal/Success_Modal";

const CustomControl = ({ children, ...props }) => {
  const Icon = props.selectProps.icon;

  return (
    <components.Control {...props}>
      {Icon && (
        <span className="select_icon_wrapper">
          <Icon className="select_icon" />
        </span>
      )}
      {children}
    </components.Control>
  );
};

function Banner({ value, onChange }) {
  const {
    register,
    control,
    reset,
    handleSubmit,
    watch, getValues,
    setValue,
    formState: { errors },
  } = useForm();
  const { IMG_URL, Select2Data, getData, appSetup, postData } = useContext(Context);
  const [tripType, setTripType] = useState({ name: "oneway", value: 2 });
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const handleWrapperClick = () => {
    inputRef.current.showPicker(); // opens calendar (modern browsers)
    inputRef.current.focus(); // fallback
  };

  const [tripData, settripData] = useState({});
  const [ApiError, setApiError] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [show2Modal, setShow2Modal] = useState(false);
  const [api2Error, setApi2Error] = useState("");

  const [dataBanner, setDataBanner] = useState();
  const getAllDatabanner = async () => {
    const res = await getDataBanner();

    if (res?.success) {
      setDataBanner(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [cabType, setCabType] = useState();
  const getAllCabType = async () => {
    const res = await getcabs({ term: "" });

    if (res?.success) {
      setCabType(await Select2Data(res?.data, "cab_type_id"));
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [locations, setLocations] = useState();
  const getAllLocations = async () => {
    const res = await getLocation();

    if (res?.success) {
      setLocations(await Select2Data(res?.data, "location_id"));
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  const [cancelReason, setCancelReason] = useState([]);

  const getAllCancelReason = async () => {
    const res = await GetCancelltionReason();

    if (res?.success) {
      setCancelReason(await Select2Data(res?.data, "reason_id"));
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  console.log({ errors });

  useEffect(() => {
    getAllDatabanner();
    getAllCabType();
    getAllLocations();
    getAllCancelReason();
  }, []);

  const pickupLocation = watch("pickup_location");
  const dropLocation = watch("drop_location");
  const cabTypeId = watch("cab_type_id");
  const selectedTripType = watch("trip_type");

  const filteredPickupLocations = locations?.filter(
    (loc) => loc.value !== dropLocation?.value,
  );

  const onSubmit = async (data) => {
    if (ApiError) {
      return;
    }
    // console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("no_of_passenger", data.no_of_passenger);
    formData.append("location_id", data.pickup_location?.value);
    formData.append("drop_location", data.drop_location);
    formData.append("trip_type", data.trip_type); // ✅ IMPORTANT

    formData.append("start_date", data.start_date);
    formData.append("cab_type_id", data.cab_type_id?.value);

    // // Debug
    // for (let pair of formData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    const response = await postData("/without-login/booking/step-1", formData);
    if (response?.success) {
      reset();
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
        navigate(`/booking-details/${encodeId(response?.data?.id)}`);
      }, 2500);
    } else {
      setApi2Error(response?.errors);
      console.error("Form submission failed:", response?.errors);
    }
  };

  const getAmountOfTrip = async () => {
    const TripData = await getData(
      `/without-login/booking?location_id=${pickupLocation?.value ||
      ""}&cab_type_id=${cabTypeId?.value ||
      ""}&trip_type=${selectedTripType || ""}`,
    );
    if (TripData?.success) {
      settripData(TripData?.data);
      setApiError("");
    } else {
      setApiError(TripData?.errors);
    }
  };

  useEffect(() => {
    getAmountOfTrip();
  }, [cabTypeId, pickupLocation, selectedTripType]);

  const [bookingData, setBookingData] = useState()
  const [Api3Error, setApi3Error] = useState("");

  const getBookedBooking = async () => {
    const booking_id = getValues("booking_id");
    if (!booking_id) {
      setBookingData(null);
      return;
    }
    const bookData = await getData(
      `/without-login/booking/get?booking_id=${booking_id || ""}`,
    );
    if (bookData?.success) {
      setBookingData(bookData?.data);
      setApi3Error("");
    } else {
      setBookingData(null);
      setApi3Error(bookData?.errors);
    }


  }
  const CancelRide = async (data) => {
    console.log({ CancelRide: data });

    if (Api3Error) {
      return;
    }
    const formData = new FormData();

    formData.append("reason_id", data.reason_id?.value);
    formData.append("booking_id", bookingData?.id);
    formData.append("upi_id", data.upi_id);
    // // Debug
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await postData("/without-login/booking/cancel  ", formData);

    console.log({ response });

    if (response?.success) {
      // reset();
      setShow2Modal(true);
      setTimeout(() => {
        setShow2Modal(false);
      }, 2500);
    } else {
      setApi3Error(response?.errors);
      console.error("Form submission failed:", response?.errors);
    }

  }
  return (
    <section className="home_banner">
      <div className="container-fluid ">
        <div className="banner_holder">
          <img
            src={IMG_URL + dataBanner?.image}
            // src={dataBanner?.image"/assets/images/home/banner/banner-img.png"}
            alt="banner"
            className="banner_img"
          />

          <div className="banner_text_holder">
            <p className="book">Book an</p>
            <h5 className="infinity">INFINITY</h5>
            <p className="destination">to Your Destination!</p>
          </div>
        </div>
        <div className="container_holder">
          <div className="container p-0">
            <div className="booking_section">
              <div className="booking_header_wrapper">
                <div className="booking_header">
                  <h5 className="booking_title">
                    <span className="highlight"> INFINITY </span> LADAKH TAXI{" "}
                    <span className="small_text"> for you! </span>
                  </h5>
                </div>

                {/* Toggle Buttons */}
                <div className="trip_toggle">
                  <button
                    className={`toggle_btn ${tripType?.name === "oneway" ? "active" : ""
                      }`}
                    onClick={() => setTripType({ name: "oneway", value: 2 })}
                  >
                    Booking
                  </button>

                  <button
                    className={`toggle_btn ${tripType?.name === "tour" ? "active" : ""
                      }`}
                    onClick={() => setTripType({ name: "tour", value: 1 })}
                  >
                    Cab Cancel
                  </button>
                </div>
              </div>

              {/* Content Change */}
              <div className="trip_content">
                {/* ========== ONE WAY ========== */}
                {tripType?.name === "oneway" && (
                  <div>
                    {/* Form Fields */}
                    <Form>
                      <Row className="mb-3">
                        <Col md={6} sm={6}>
                          <div className="select_wrapper">
                            <Controller
                              name="pickup_location"
                              control={control}
                              rules={{
                                required: "Plese Select Pickup location",
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={filteredPickupLocations}
                                  placeholder="Pick Up Location"
                                  classNamePrefix="custom_select"
                                  isSearchable
                                  components={{ Control: CustomControl }}
                                  icon={FaMapMarkerAlt}
                                  value={field.value}
                                  onChange={(val) => field.onChange(val)}
                                />
                              )}
                            />
                          </div>
                          {errors?.pickup_location && (
                            <p className="text-danger mt-1 mb-0">
                              {errors?.pickup_location.message}
                            </p>
                          )}
                        </Col>

                        <Col md={6} sm={6}>
                          <div className="select_wrapper">
                            <Form.Control
                              type="text"
                              name="drop_location"
                              placeholder="Drop Location..."
                              classNamePrefix="custom_form_control"
                              className={classNames("custom_form_control", {
                                "is-invalid": errors?.drop_location,
                              })}
                              {...register("drop_location", {})}
                            />
                          </div>
                          {errors?.drop_location && (
                            <p className="text-danger mt-1">
                              {errors?.drop_location.message}
                            </p>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={3} sm={3}>
                          <div className="select_wrapper">
                            <Form.Label className="custom_form_check">
                              Select Trip Type
                            </Form.Label>

                            <div className="d-flex gap-3">
                              <Form.Check
                                type="radio"
                                label="Drop"
                                value="drop"
                                {...register("trip_type", {
                                  required: "Please select type",
                                })}
                              />

                              <Form.Check
                                type="radio"
                                label="Return"
                                value="return"
                                {...register("trip_type")}
                              />
                            </div>

                            {errors?.trip_type && (
                              <span className="text-danger">
                                {errors.trip_type.message}
                              </span>
                            )}
                          </div>
                        </Col>

                        <Col md={3} sm={3}>
                          <Controller
                            name="cab_type_id"
                            control={control}
                            rules={{ required: "Plese Select Vehicle type" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={cabType}
                                placeholder="Select Vehicle Type"
                                classNamePrefix="custom_select"
                                components={{ Control: CustomControl }}
                                icon={FaCar}
                                value={field.value}
                                onChange={(val) => field.onChange(val)}
                              />
                            )}
                          />

                          {errors?.cab_type_id && (
                            <p className="text-danger mt-1">
                              {errors?.cab_type_id.message}
                            </p>
                          )}
                        </Col>
                        {/* Date */}
                        <Col md={3} sm={3}>
                          <div
                            className="custom_date_wrapper"
                            style={{ cursor: "pointer" }}
                          >
                            <Controller
                              name="start_date"
                              control={control}
                              rules={{ required: "Please Select Start date" }}
                              render={({ field }) => {
                                const today = new Date();

                                // 👉 add 10 days
                                const minDate = new Date();
                                minDate.setDate(today.getDate());

                                return (
                                  <DatePicker
                                    placeholderText="Select Start Date"
                                    showIcon
                                    selected={field.value}
                                    onChange={(date) => field.onChange(date)}
                                    dateFormat="dd/MM/yyyy"
                                    minDate={minDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                    isClearable
                                  />
                                );
                              }}
                            />
                          </div>
                          {errors?.start_date && (
                            <p className="text-danger mt-1">
                              {errors?.start_date.message}
                            </p>
                          )}
                        </Col>

                        <Col md={3} sm={3}>
                          <Form.Control
                            type="text"
                            name="no_of_passenger"
                            placeholder="No. of Passengers"
                            classNamePrefix="custom_form_control"
                            className={classNames("custom_form_control", {
                              "is-invalid": errors?.no_of_passenger,
                            })}
                            {...register("no_of_passenger", {
                              required: "Enter No. of Passengers",
                              min: {
                                value: 1,
                                message:
                                  "No. of Passengers cannot be less than 0",
                              },
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "-" || // Prevent negative sign
                                e.key === "+" || // Prevent plus sign
                                e.key === "e" || // Prevent scientific notation
                                e.key === "E" || // Prevent scientific notation
                                e.key === "." || // Prevent decimal point (if only integers allowed)
                                (isNaN(Number(e.key)) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />

                          {errors?.no_of_passenger && (
                            <p className="text-danger mt-1">
                              {errors?.no_of_passenger.message}
                            </p>
                          )}
                        </Col>
                      </Row>

                      <p className="advance_text">
                        Booking needs to be done at least 10 days in advance to
                        ensure car availability.
                      </p>
                      {ApiError && (
                        <p className="advance_text text-danger">{ApiError}</p>
                      )}

                      <div className="form_box_holder">
                        <Row className="mb-4">
                          <Col lg={4} md={4} className="mb-2">
                            <div className="left_box">
                              <p className="price_text">
                                {selectedTripType === "return"
                                  ? formatAmount(tripData?.return_amount)
                                  : formatAmount(tripData?.drop_amount)}{" "}
                                / car
                              </p>
                              <p className="includes">
                                *Includes: Driver, fuel, tolls, parking fees
                                included
                              </p>
                            </div>
                          </Col>
                          <Col lg={8} md={8} className="mb-2">
                            <div className="right_box">
                              <p className="trip">
                                Trip:{" "}
                                {pickupLocation?.label || "Pickup Location"} →{" "}
                                {dropLocation || "Drop Location"}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {api2Error && (
                        <p className="advance_text text-danger">{api2Error}</p>
                      )}

                      {/* <p className="total_dist">Total distance: - km</p> */}
                      <div
                        className="common_btn_holder"
                        // onClick={() => navigate("/booking-details")}
                        onClick={handleSubmit(onSubmit)}
                      >
                        {" "}
                        <Yellow_BG_Btn text="BOOK YOUR RIDE" />
                      </div>
                    </Form>
                  </div>
                )}

                {/* ========== TOUR========== */}
                {tripType?.name === "tour" && (
                  <div>
                    <div>
                      {/* <Form onSubmit={handleSubmit(getBookedBooking)}> */}
                      {/*  Booking ID + Search */}
                      <Row className="mb-3 align-items-center">
                        <Col lg={6} md={6} sm={12} className="mb-3">
                          <input
                            type="text"
                            placeholder="Enter Booking ID"
                            className="form-control"
                            {...register("booking_id", {})}
                            onKeyDown={(e) => {
                              if (
                                e.key === "-" || // Prevent negative sign
                                e.key === "+" || // Prevent plus sign
                                e.key === "e" || // Prevent scientific notation
                                e.key === "E" || // Prevent scientific notation
                                e.key === "." || // Prevent decimal point (if only integers allowed)
                                (isNaN(Number(e.key)) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                          <div className="search_btn">
                            <Yellow_BG_Btn text="Search" onClick={getBookedBooking} />
                          </div>
                        </Col>
                      </Row>

                      {/* </Form> */}

                      <Form>
                        <Row className="align-items-center">
                          <Col lg={6} md={6} sm={12}>

                            {/* 
                            {bookingData && (
                              <div className="booking_card">
                                <ul>
                                  <li><strong>Booking ID:</strong> {bookingData.booking_id}</li>
                                  <li><strong>Status:</strong> {bookingData.status}</li>
                                  <li><strong>Pickup:</strong> {bookingData.location?.name}</li>
                                  <li><strong>Drop:</strong> {bookingData.destinationDescription}</li>
                                  <li><strong>Vehicle:</strong> {bookingData.cab_type?.name}</li>
                                </ul>
                              </div>
                            )} */}
                            <div
                              style={{
                                background: "#fff",
                                padding: "15px",
                                borderRadius: "8px",
                                marginBottom: "20px",
                              }}
                            >
                              <ul
                                style={{
                                  listStyle: "none",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                <li className="mb-2">
                                  <strong>Booking ID:</strong> {bookingData?.booking_id || ""}
                                </li>
                                <li className="mb-2">
                                  <strong>Status:</strong> {bookingData?.booking_status?.name || ""}
                                </li>
                                <li className="mb-2">
                                  <strong>Pickup Location:</strong> {bookingData?.location?.name || ""}
                                </li>
                                <li className="mb-2">
                                  <strong>Drop Location:</strong> {bookingData?.destinationDescription || ""}
                                </li>
                                <li className="mb-2">
                                  <strong>Vehicle Type:</strong> {bookingData?.cab_type?.name || ""}
                                </li>

                                {bookingData && <>
                                  <li className="mb-2">
                                    <strong>Total Fare:</strong> {formatAmount(bookingData?.fare) || ""}
                                  </li>
                                  <li className="mb-2">
                                    <strong>GST applied:</strong> {formatAmount(bookingData?.gst_charges) || ""}
                                  </li>
                                  <li className="mb-2">
                                    <strong>Cancellation Charges:</strong> {formatAmount((bookingData?.sub_total * appSetup?.cancel_percentage) / 100) || ""}
                                  </li>
                                  <li className="mb-2">
                                    <strong>Refund Amount:</strong> {formatAmount(
                                      bookingData?.sub_total -
                                      (bookingData?.sub_total * appSetup?.cancel_percentage) / 100) || ""}
                                  </li>
                                </>
                                }
                              </ul>
                            </div>

                            {Api3Error && (
                              <p className="advance_text text-danger">{Api3Error}</p>
                            )}
                          </Col>

                          <Col lg={6} md={6} sm={12}>
                            <Row>
                              <Col md={12} className="mb-4">


                                <Controller
                                  name="reason_id"
                                  control={control}
                                  rules={{ required: "Plese Select Cancellation Reason" }}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      options={cancelReason}
                                      placeholder="Select Cancellation Reason"
                                      classNamePrefix="custom_select"
                                      value={field.value}
                                      onChange={(val) => field.onChange(val)}
                                    />
                                  )}
                                />
                                {errors?.reason_id && (
                                  <p className="text-danger mt-1">
                                    {errors?.reason_id.message}
                                  </p>
                                )}
                              </Col>

                              <Col md={12} className="mb-4">
                                <input
                                  type="text"
                                  placeholder="Enter UPI ID"
                                  className="form-control"
                                  {...register("upi_id", {
                                    required: "UPI ID is required",
                                    pattern: {
                                      value: /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
                                      message: "Enter a valid UPI ID",
                                    },
                                  })}
                                />

                                {errors?.upi_id && (
                                  <p className="text-danger mt-1">
                                    {errors?.upi_id.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <p className="advance_text">
                          The booking can be cancelled until {appSetup?.cancel_days || "10"} days before the start date and a {appSetup?.cancel_percentage || "17"}% cancellation fee will apply.

                        </p>

                        {/* 🚫 Cancel Button */}
                        <div className="common_btn_holder">
                          <Yellow_BG_Btn text="CANCEL RIDE" onClick={handleSubmit(CancelRide)} disabled={!bookingData} />
                        </div>
                      </Form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Success_Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          successText="Step 1 Completed Of Booking"
        />
        <Success_Modal
          show={show2Modal}
          onHide={() => setShow2Modal(false)}
          successText="Booking Cancelled Successfully!"
        />
      </div>
    </section >
  );
}

export default Banner;
